var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage"},[_c('div',{staticClass:"custom__loader"}),_c('HomeBanner'),_c('ServiceCard'),_c('CasesBlock'),_c('AboutBlock'),_c('PartnershipBlock'),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('FeedbackForm')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }